import styled from 'styled-components'

import CircularProgress from '@material-ui/core/CircularProgress';

export const CustomCircularProgress = styled(CircularProgress)`
  && {
    color: red;
  }
`